export function preventEnterDuringApplePay(e: KeyboardEvent): void {
  if (e.key == 'Enter' && globalThis.Checkout.store?.payment?.type.get() == 'apple-pay') {
    e.preventDefault()
  }
}
